"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmWasmModule = void 0;
const util_1 = require("../util");
const stargate_1 = require("@cosmjs/stargate");
const tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
const query_1 = require("cosmjs-types/cosmwasm/wasm/v1/query");
const base_1 = __importDefault(require("./base"));
const generic_1 = require("../util/generic");
class CosmWasmModule extends base_1.default {
    constructor(sdkProvider, cosmClient) {
        super(sdkProvider);
        this.cosmWasmClient = cosmClient;
    }
    static instanceWithChainInfo(sdkProvider, chainInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            if (chainInfo.activeRpc) {
                try {
                    const tmClient = yield tendermint_rpc_1.Tendermint37Client.connect(chainInfo.activeRpc);
                    return CosmWasmModule.instanceWithTmClient(sdkProvider, tmClient);
                }
                catch (error) {
                    // empty catch
                }
            }
            const { client, rpcUrl } = yield (0, generic_1.getBestRpcTmClient)(chainInfo.bestRpcs.map(r => r.address));
            chainInfo.activeRpc = rpcUrl;
            return CosmWasmModule.instanceWithTmClient(sdkProvider, client);
        });
    }
    static instanceWithTmClient(sdkProvider, tmClient) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseClient = new stargate_1.QueryClient(tmClient);
            const rpcClient = (0, stargate_1.createProtobufRpcClient)(baseClient);
            const cosmWasmClient = new query_1.QueryClientImpl(rpcClient);
            return new CosmWasmModule(sdkProvider, cosmWasmClient);
        });
    }
    static instance(sdkProvider, tmRpcUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const tmClient = yield tendermint_rpc_1.Tendermint37Client.connect(tmRpcUrl);
            return CosmWasmModule.instanceWithTmClient(sdkProvider, tmClient);
        });
    }
    queryCosmwasmBalance(walletAddress, contractAddr) {
        return __awaiter(this, void 0, void 0, function* () {
            const finalResult = {
                contractAddress: contractAddr,
                balance: util_1.NumberUtils.BN_ZERO,
            };
            try {
                const smartContract = yield this.cosmWasmClient.SmartContractState({
                    address: contractAddr,
                    queryData: Buffer.from(JSON.stringify({ balance: { address: walletAddress } }), 'utf-8'),
                });
                const result = Buffer.from(smartContract.data).toString("utf-8");
                const balanceJson = JSON.parse(result);
                finalResult.balance = util_1.NumberUtils.bnOrZero(balanceJson.balance);
            }
            catch (err) {
                console.error(err);
            }
            return finalResult;
        });
    }
    queryCosmwasmBalances(walletAddress, contractAddresses) {
        return __awaiter(this, void 0, void 0, function* () {
            const balancesMap = yield Promise.all(contractAddresses.map((contractAddr) => this.queryCosmwasmBalance(walletAddress, contractAddr)));
            return balancesMap.reduce((prev, balance) => {
                prev[balance.contractAddress] = balance.balance;
                return prev;
            }, {});
        });
    }
}
exports.CosmWasmModule = CosmWasmModule;
